export default __webpack_public_path__ + "user-md-symbol.png";